import { IonIcon, IonSpinner } from '@ionic/react';
import React from 'react';
import styled, { css } from 'styled-components';
import { addOutline, removeOutline } from 'ionicons/icons';
import ToastService from '../services/ToastService';

const Wrapper = styled.div`
    display:flex;
    justify-content:space-between;
    align-items:center;
    border:1px solid ${props => props.color};
    height:38px;
    width:101px;
    padding:0 0.5rem;
    border-radius:6px;
`;

const Functional = styled(IonIcon)<any>`
    color:${props => props.color};
    font-size:20px;
    ${props => props.disabled && css`
        opacity:0.5;
    `};
`;

const Value = styled.div`
    padding: 0 0.5rem;
    color:${props => props.color};
`;

export const QuantityManager = (props:any) => {

    const { value, incrementer, errorMessage, decrementer, color, isLoading, disableAdd, disableRemove } = props;

    function increment() {
        if(disableAdd) {
            if(errorMessage) {
                ToastService.showToast(errorMessage)
            }
            return;
        }
        incrementer();
    }

    function decrement() {
        if(disableRemove) {
            if(errorMessage) {
                ToastService.showToast(errorMessage, { autoClose: 2000 })
            }
            return;
        }
        decrementer();
    }

    return (
        <Wrapper color={color} >
            <Functional disabled={disableRemove} onClick={decrement} color={color} src={removeOutline} />
            <Value color={color} >{isLoading ? <IonSpinner name='dots' /> : value ?? 0}</Value>
            <Functional disabled={disableAdd} onClick={increment} color={color} src={addOutline} />
        </Wrapper>
    )
}
